export default __webpack_public_path__ + "static/icon-chemicals-fcf52c513db9c15372f4526a795fe75f.svg";